import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", { class: "io-mfe-ig-dt-col-left-spacer" }, null, -1)
const _hoisted_3 = {
  key: "drgModifier",
  class: "io-mfe-ig-dt-col-modifier"
}
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = {
  class: "pdx io-mfe-ig-dt-col-pdx",
  key: "pdx"
}
const _hoisted_6 = {
  key: "code",
  class: "io-mfe-ig-dt-col-code"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: "description",
  class: "io-mfe-ig-dt-col-desc"
}
const _hoisted_9 = { class: "ellipsis" }
const _hoisted_10 = {
  key: "poa",
  class: "io-mfe-ig-dt-col-poa"
}
const _hoisted_11 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_12 = {
  key: "poa",
  class: "io-mfe-ig-dt-col-poa"
}
const _hoisted_13 = {
  key: 2,
  class: "io-mfe-ig-dt-col-quality-risk"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: "quality",
  class: "io-mfe-ig-dt-col-quality"
}
const _hoisted_17 = {
  key: "risk",
  class: "io-mfe-ig-dt-col-risk"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

import _ from 'lodash'
import {QTableProps, useQuasar} from 'quasar';
import DataTable from 'components/grouper-common/DataTable.vue';
import { ref, watch } from 'vue';
import { useGrouperStore } from 'stores/grouper-store';
import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { CodeType } from 'src/contracts/codeType';
import { storeToRefs } from 'pinia';
import {
    presentOnAdmissionDisplayMap,
    presentOnAdmissionMap,
    presentOnAdmissionsDisplayValues
} from 'src/common/poaUtll';
import { useLayoutStore } from 'stores/layout-store';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
import { getDxColumns } from 'components/grouper-common/common-constants';
import { useSearchStore } from 'stores/search-store';
import { vOnClickOutside } from '@vueuse/components';
import DisplayProperty from 'components/global-common/DisplayProperty.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosisPane',
  setup(__props) {

const cloneDeep = require('lodash.clonedeep');

const grouperStore = useGrouperStore();
const searchStore = useSearchStore();
const $q = useQuasar()
const { diagnosisCodes, resequence, editsSelectedCode, isPrimaryDrgMs, readOnly } = storeToRefs(grouperStore);

const layoutStore = useLayoutStore()
const { layoutMode, researchTab } = storeToRefs(layoutStore);

let currentCode: DiagnosisCode | undefined = undefined;
let currentRow = ref(-1);
const columns = ref<QTableProps['columns']>(getDxColumns(layoutMode.value));

watch(layoutMode, (newLayoutMode: GrouperLayoutMode) => {
  columns.value = getDxColumns(newLayoutMode);
});

function rowClasses(index: number, row: DiagnosisCode): string {
    const classList = [];

    if(row?.code === editsSelectedCode.value) {
      classList.push('highlight-row');
    }

    if (editing(index)) {
        classList.push('editing-row');
    } else if (index % 2 === 0) {
        classList.push('iodine-alternate-table-row');
    } else {
      classList.push('bg-white');
      classList.push('text-black');
    }

    if (index == 0) {
      classList.push('primary-row');
    }


    return classList.join(' ');
}

function deleteCode(index: number): void {
    if (currentRow.value !== -1) {
      resetCode(currentRow.value);
    }
    diagnosisCodes.value?.splice(index, 1);
    currentRow.value = -1;
    grouperStore.recalculateNeeded();
}

function editCode(index: number, editing = true): void {

    if (currentRow.value != index) {

      // reset previous row before editing new row
      if (currentRow.value > -1 && currentCode) {
        diagnosisCodes.value[currentRow.value] = currentCode;
      }

      // make a copy of the row for reset
      currentCode = index >= 0 ? cloneDeep(diagnosisCodes.value[index]) : undefined;
      currentRow.value = editing ? index : -1;
    }
}

function editing(index: number): boolean {
    return !readOnly.value && currentRow.value === index;
}

function saveCode() {

  if (searching > 0) {
    return;
  }

  const editingCode = diagnosisCodes.value[currentRow.value];
    if (editingCode.code && editingCode.description && testCode(editingCode.code)) {
      currentRow.value = -1;

      if (editingCode.code != currentCode?.code) {
        grouperStore.recalculateNeeded();
      }
    }
}

function createOutsideClickHandler(index: number): [(evt: unknown) => void, {ignore?: string[]}] {
  return [
    () => {
      if (currentRow.value == index) {
        resetCode(index);
      }

      editsSelectedCode.value = '';
    },
    { ignore: ['.q-menu']}
  ];
}

function resetCode(index: number): void {
    diagnosisCodes.value[index] = currentCode || diagnosisCodes.value[index];
    currentRow.value = -1;
    currentCode = undefined;
}

function makePrinciple(index: number): void {

  if (currentRow?.value === index) {
    resetCode(index);
  }

    diagnosisCodes.value?.unshift(diagnosisCodes.value?.splice(index, 1)[0]);
    grouperStore.recalculateNeeded();
}

function testCode(code: string): boolean {

  code = code.toUpperCase();
  var regExp1 = new RegExp('^[A-Z0-9]+\\.$'); // contains dot at the end
  var regExp2 = new RegExp('^[A-TU-Z][0-9][0-9AB]\\.?[0-9A-TV-Z]{0,4}'); // valid icd10 code

  return !regExp1.test(code) && regExp2.test(code);
}

let searching = 0;
async function searchCodes(text: string | undefined, index: number) {
  searching++;
  try {
    if (testCode(text as string)) {
      const code = await searchStore.quickAddCodeSearch(text as string, CodeType.Diagnosis);
      if (code) {
        if (!diagnosisCodes.value[index].code.includes('.') && code.value.includes('.')) {
          diagnosisCodes.value[index].code = code.value;
        }
        diagnosisCodes.value[index].description = code.shortDescription || code.mediumDescription;
      } else {
        diagnosisCodes.value[index].description = '';
      }
    } else {
      diagnosisCodes.value[index].description = '';
    }
  } catch (e) {
    diagnosisCodes.value[index].description = '';
  } finally {
    searching--;
  }
}

function setPOA(value: string, index: number) {

  if (currentRow.value === index) {
    resetCode(currentRow.value);
  }

  const newPoa = presentOnAdmissionDisplayMap[value];
  if (diagnosisCodes.value[index].present_on_admission != newPoa) {
    diagnosisCodes.value[index].present_on_admission = newPoa;
    grouperStore.recalculateNeeded();
  }
}

function titleText() {
    return `Diagnoses (${diagnosisCodes.value?.length || 0})`
}

function moveElements(arr: unknown[], newPosition: number, oldPosition: number) {
  let element = arr.splice(newPosition, 1)[0];
  arr.splice(oldPosition, 0, element);

  return arr;
}

function dxReorderd(event: CustomEvent) {
  if(resequence.value) {
    const opts = {
      color: 'white',
      textColor: 'black', // TODO this wasn't on the props not sure if its important
      html: true,
      title: '<span class="q-dialog-custom__title">Resequencing Conflict</span>',
      message: '<div class="q-dialog-custom__body">' +
                  '<div style="margin-bottom: 20px">Moving this code is in conflict with automatic resequencing.</div>' +
                  '<div>Would you like to proceed with moving and turn off automatic resequencing?</div>' +
              '</div>',
      ok: {
        class: 'dialog-button',
        label: 'Yes'
      },
      cancel: {
        class: 'dialog-button',
        label: 'No'
      }
    }
    $q.dialog(opts).onOk(() => {
      grouperStore.changeResequence();
    }).onCancel(() => {
      const diagnosisCodesArray = diagnosisCodes.value;
      moveElements(diagnosisCodesArray, _.get(event, 'newIndex') as unknown as number, _.get(event, 'oldIndex') as unknown as number)
      diagnosisCodes.value = diagnosisCodesArray;
    })
  } else {
    grouperStore.recalculateNeeded();
  }
}

// eslint-disable-next-line
function editClicked(code: DiagnosisCode) {
  if(!readOnly.value) {
    layoutStore.setResourcesSelected(true);
    researchTab.value = 'edits';
  }
}

function openInSearch(code: DiagnosisCode) {
  useLayoutStore().setSearchSelected(true);
  useSearchStore().changeSearchText(code.code);
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["diagnosis-table-container", {'diagnosis-table-container-readonly': _unref(readOnly)}])
  }, [
    _createVNode(DataTable, {
      "drag-disallowed": _unref(readOnly),
      title: titleText(),
      rows: _unref(diagnosisCodes),
      columns: columns.value,
      "collapse-type": 'icon-based',
      type: _unref(CodeType).Diagnosis,
      onReorder: dxReorderd,
      onDragStart: _cache[2] || (_cache[2] = ($event: any) => (resetCode(_unref(currentRow))))
    }, {
      "dt-thead": _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass(["ellipsis", (col.headerClasses ? col.headerClasses : '') + ` io-mfe-ig-dt-col-${col.name}`]),
                key: col.name
              }, _toDisplayString(col.label), 3))
            }), 128))
          ])
        ])
      ]),
      "dt-rows": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diagnosisCodes), (row, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass(rowClasses(index, row)),
            onClick: ($event: any) => (editCode(index))
          }, [
            _hoisted_2,
            _createElementVNode("td", {
              key: "action",
              class: _normalizeClass(["io-mfe-ig-dt-col-actions", {'io-mfe-ig-dt-col-actions-readonly': _unref(readOnly)}])
            }, [
              _createVNode(_component_q_btn_dropdown, {
                disable: _unref(readOnly),
                "no-caps": "",
                dense: "",
                flat: "",
                unelevated: "",
                class: "text-none io-mfe-ig-icon-button-small q-btn--round",
                "dropdown-icon": "fa-solid fa-ellipsis-vertical",
                size: "sm",
                "content-class": "io-mfe-ig-action-menu"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        clickable: "",
                        onClick: ($event: any) => (deleteCode(index))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                class: "io-mfe-ig-icon-medium",
                                name: "fa-light fa-circle-trash"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Delete Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        clickable: "",
                        onClick: ($event: any) => (makePrinciple(index))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                class: "io-mfe-ig-icon-medium",
                                name: "fa-light fa-arrow-up"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Make Principal")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        clickable: "",
                        onClick: ($event: any) => (openInSearch(row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                class: "io-mfe-ig-icon-medium",
                                name: "fa-light fa-magnifying-glass"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Open in Search")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["disable"])
            ], 2),
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_q_chip, { class: "Pdx" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Pdx "),
                          (!_unref(readOnly))
                            ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Principal Diagnosis")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (_unref(isPrimaryDrgMs))
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.drgModifier, (drgModifier, index) => {
                        return (_openBlock(), _createBlock(_component_q_chip, {
                          key: index,
                          class: _normalizeClass(drgModifier)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(drgModifier) + " ", 1),
                            (!_unref(readOnly))
                              ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(drgModifier === "MCC" ? '(MCC) Major Complication and Comorbidity' : '(CC) Complication and Comorbidity'), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (row.soi_level != null)
                          ? (_openBlock(), _createBlock(DisplayProperty, {
                              key: 0,
                              label: "SOI:",
                              value: row.soi_level || '',
                              horizontal: true,
                              size: "small"
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true),
                        (row.rom_level != null)
                          ? (_openBlock(), _createBlock(DisplayProperty, {
                              key: 1,
                              label: "ROM:",
                              value: row.rom_level || '',
                              horizontal: true,
                              size: "small"
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                      ], 64))
                ])
              ])
            ]),
            _createElementVNode("td", _hoisted_6, [
              (!editing(index))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (row.edit)
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          name: "fa-solid fa-flag-pennant",
                          size: "xs",
                          class: _normalizeClass(["edit-flag", row.edit.level == 'Critical' ? 'critical' : 'warning']),
                          onClick: ($event: any) => (editClicked(row))
                        }, {
                          default: _withCtx(() => [
                            (!_unref(readOnly))
                              ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                  key: 0,
                                  "max-width": "300px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Edits Available")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(row.code), 1)
                  ]))
                : _createCommentVNode("", true),
              (editing(index))
                ? (_openBlock(), _createBlock(_component_q_input, {
                    key: 1,
                    dense: "",
                    outlined: "",
                    modelValue: row.code,
                    "onUpdate:modelValue": [($event: any) => ((row.code) = $event), ($event: any) => (searchCodes(row.code, index))],
                    modelModifiers: { trim: true },
                    placeholder: "Add Code",
                    autofocus: "",
                    disable: _unref(readOnly),
                    onKeydown: [
                      _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["enter"])),
                      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["tab"]))
                    ]
                  }, {
                    prepend: _withCtx(() => [
                      (row.edit)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-solid fa-flag-pennant",
                            size: "16px",
                            class: _normalizeClass(["edit-flag", row.edit.level == 'Critical' ? 'critical' : 'warning']),
                            onClick: ($event: any) => (editClicked(row))
                          }, {
                            default: _withCtx(() => [
                              (!_unref(readOnly))
                                ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Edits Available")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    append: _withCtx(() => [
                      (row.description === '' && row.code)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-light fa-circle-exclamation",
                            size: "16px"
                          }))
                        : (row.description && row.code)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 1,
                              name: "fa-light fa-circle-trash",
                              onClick: ($event: any) => (deleteCode(index)),
                              size: "16px"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disable"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_8, [
              (!_unref(readOnly))
                ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.description), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, _toDisplayString(row.description), 1)
            ]),
            (!editing(index))
              ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                  (row.present_on_admission && row.present_on_admission.trim())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(presentOnAdmissionMap)[row.present_on_admission]), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_q_icon, {
                          name: "fa-regular fa-triangle-exclamation",
                          class: "poa-exclamation",
                          size: "16px"
                        }),
                        (!_unref(readOnly))
                          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("No Present on Admission defined for " + _toDisplayString(row.code), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                ]))
              : _createCommentVNode("", true),
            (editing(index))
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn_dropdown, {
                      "content-class": "io-mfe-ig-poa-portal",
                      "dropdown-icon": "fa-solid fa-caret-down",
                      flat: "",
                      unelevated: "",
                      label: _unref(presentOnAdmissionMap)[row.present_on_admission as string] || 'Set POA',
                      class: "poa-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presentOnAdmissionsDisplayValues), (poa, poaIndex) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: poaIndex,
                                clickable: "",
                                onClick: ($event: any) => (setPOA(poa, index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(poa), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(layoutMode) == _unref(GrouperLayoutMode).consolidated)
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.quality, (quality, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(quality.name)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(quality.name) + " ", 1),
                        (!_unref(readOnly))
                          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(quality.tooltip[0]), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.risk, (risk, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(risk.name)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(risk.name) + " ", 1),
                        (!_unref(readOnly))
                          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                              default: _withCtx(() => [
                                (risk.tooltip.length == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(risk.tooltip[0]), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      _createVNode(_component_q_list, { dense: "" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(risk.tooltip, (tip, index) => {
                                            return (_openBlock(), _createBlock(_component_q_item, { key: index }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(tip), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(layoutMode) != _unref(GrouperLayoutMode).consolidated)
              ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.quality, (quality, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(quality.name)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(quality.name) + " ", 1),
                        (!_unref(readOnly))
                          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(quality.tooltip[0]), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(layoutMode) != _unref(GrouperLayoutMode).consolidated)
              ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.risk, (risk, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(risk.name)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(risk.name) + " ", 1),
                        (!_unref(readOnly))
                          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                              default: _withCtx(() => [
                                (risk.tooltip.length == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(risk.tooltip[0]), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(_component_q_list, { dense: "" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(risk.tooltip, (tip, index) => {
                                            return (_openBlock(), _createBlock(_component_q_item, { key: index }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(tip), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_1)), [
            [_unref(vOnClickOutside), createOutsideClickHandler(index)]
          ])
        }), 128))
      ]),
      _: 1
    }, 8, ["drag-disallowed", "title", "rows", "columns", "type"])
  ], 2))
}
}

})